import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=5d60b126&scoped=true"
import script from "./list-table.vue?vue&type=script&lang=js"
export * from "./list-table.vue?vue&type=script&lang=js"
import style0 from "./list-table.vue?vue&type=style&index=0&id=5d60b126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60b126",
  null
  
)

export default component.exports